(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("visibilityWizard", {
        templateUrl: "app/learningPaths/visibility/visibilityWizard.component.html",
        controller: ["learningPathResource", "messageService", "$sessionStorage", "$state", "_", "$timeout", VisibilityWizardCtrl],
        controllerAs: "vm"
    });
    function VisibilityWizardCtrl(learningPathResource, messageService, $sessionStorage, $state, _, $timeout) {
        var vm = this;
        vm.language = "";
        //Variables that are used to save selection through steps
        vm.learningPaths = [];
        vm.visibility = 1;
        vm.status = [];
        vm.statuses = [
            { "id": 0, "status": "Disabled" },
            { "id": 1, "status": "Assigned" },
            { "id": 2, "status": "Activated" },
            { "id": 3, "status": "Completed" },
            { "id": 4, "status": "Expired" },
            { "id": 5, "status": "Redo" },
            { "id": 6, "status": "AccessExpired" }
        ];
        //Variables to form binding model for save
        vm.selectedLearningPaths = [];
        //vm.selectedVisibility;
        //vm.selectedStatuses = [];
        //Validation variables
        vm.stepIsValid = false;
        vm.loadedStep1 = false;
        vm.loadedStep2 = false;
        //Select all check box
        vm.isCheckAllPath = false;
        vm.isCheckAllGroup = false;
        vm.areAllLearnersChecked = false;
        vm.confirmButtonEnabled = true;
        vm.step = 1;
        vm.nextButtonText = "common.next";
        vm.showErrors = false;
        //prevents changing the URL to access the other steps
        $timeout(function () {
            if ($state.current.name.indexOf("step" + vm.step) === -1) {
                $state.go("main.learningItems.visibilityWizard.step" + vm.step);
            }
        });
        vm.save = function () {
            if (!vm.confirmButtonEnabled)
                return;
            vm.confirmButtonEnabled = true;
            var paths = _.map(vm.selectedLearningPaths, function (path) {
                return { id: path.id };
            });
            learningPathResource.saveVisibilityWizard({ paths: paths, visibility: vm.visibility, status: vm.status }, function () {
                vm.goToStep(4);
                vm.clearSessionData();
            }, function () {
                vm.confirmButtonEnabled = true;
                messageService.error("common.genericError");
            });
        };
        vm.clearSessionData = function () {
            vm.dtPathInstance.DataTable.state.clear();
            $sessionStorage.visibilityWizardStep1Filters.search = "";
        };
        vm.goToStep = function (step) {
            if (vm.stepIsValid || step < vm.step) {
                vm.showErrors = false;
                if (vm.step === 1) {
                    vm.loadedStep1 = true;
                }
                vm.step = step;
                if (vm.step === 3) {
                    vm.nextButtonText = "common.confirm";
                    vm.selectedLearningPaths = _.where(vm.learningPaths, { checked: true });
                }
                else
                    vm.nextButtonText = "common.next";
                $state.go("main.learningItems.visibilityWizard.step" + vm.step);
            }
            else {
                vm.showErrors = true;
            }
        };
        //vm.clearSessionStorage();
    }
}());
